module.exports = __webpack_public_path__ + "img/satisfaction.4a969e86.png";